module.exports = __webpack_public_path__ + "static/media/spider-web.dbf3d280.svg";